/*
 * Dashboard Footer (Figma 119:15174): padding 24px 32px, column gap 6, clipped; distribuAI mark
 * 71.538 × 20.103; footer Pattern. Sides: the page gutter (--layout-page-padding-x, 32px from 1280).
 */
import distribuaiMark from '@/assets/figma/brand/distribuai-mark.svg'
import { Pattern } from './Pattern'

export function AppFooter() {
    return (
        <footer className="relative flex w-full flex-col items-start gap-[6px] overflow-clip px-[var(--layout-page-padding-x)] py-[24px]">
            <img src={distribuaiMark} alt="distribuAI" width={71.538} height={20.103} className="relative block h-[20.103px] w-[71.538px]" />
            <Pattern variant="footer" />
        </footer>
    )
}
